import React from 'react';
import '../assets/css/style2.css';
import '../assets/css/globalStyles.css';
import logo from '../assets/images/logo.png'; // Import the logo image

const Footer = () => {
  return (
    <footer className="footer mobilecenter">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="logo" style={{ paddingBottom: '10px', marginLeft: '-5px' }}>
              <a href="/kent">
                <img src={logo} alt="gallery" style={{ height: '100px' }} />
              </a>
            </div>
            <p>A luxury cottage situated in <br />Little England - Nuwara Eliya</p>
            <div className="col-12 desktopview">
              <div className="row">
                <div className="footersocials d-flex">
                  <a href="https://web.facebook.com/oryzaleisure/" target="_blank" rel="noopener noreferrer">
                    <i className="lni lni-facebook-filled" style={{ color: '#fff', marginRight: '10px' }}></i>
                  </a>
                  <a href="https://www.instagram.com/oryzaleisure/" target="_blank" rel="noopener noreferrer">
                    <i className="lni lni-instagram" style={{ color: '#fff', marginRight: '10px' }}></i>
                  </a>
                  <a href="https://wa.me/94767008800" target="_blank" rel="noopener noreferrer">
                    <i className="lni lni-whatsapp" style={{ color: '#fff' }}></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4">
            <p><a href="/kent">Home</a></p>
            <p><a href="/kent/accommodation">Rooms & Suites</a></p>
            <p><a href="/kent/dining">Dining</a></p>
            <p><a href="/kent/gallery">Gallery</a></p>
            <p><a href="/kent/offers">Offers</a></p>
            <p><a href="/kent/theKentCottage">Kent Cottage</a></p>
          </div>
          <div className="col-xl-3 col-lg-3">
            <h6 className="widget-title">Contact Us</h6>
            <p>
              <a href="mailto:reservations@oryzaleisure.com">reservations@oryzaleisure.com</a><br /><br />
              <a href="tel:+94767008800">+ 94 76 700 8800</a><br /><br />
              Little England Cottages,<br />
              Nuwara Eliya, Sri Lanka<br />
              <a href="https://maps.app.goo.gl/n65c539oLV94YZKk6" target="_blank" rel="noopener noreferrer">
                Discover On Map
              </a>
            </p>
          </div>
          <div className="col-12 desktopview">
            <div className="bottom-bar">
              <span>© 2024 Oryza Leisure. All Rights Reserved.</span>
              <span>
                <a href="/" style={{ color: 'white' }}>
                  Terms and Conditions
                </a>{' '}
                |{' '}
                <a href="/" style={{ color: 'white' }}>
                  Privacy Policy
                </a>
              </span>
              <ul className="footer-social">
                <li>
                  Designed and Developed by{' '}
                  <a href="https://ollcode.com" target="_blank" rel="noopener noreferrer">
                    <b>Ollcode</b>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 mobileview">
            <div className="bottom-bar">
              <p>© 2024 Oryza Leisure. All Rights Reserved.</p>
              <p>
                <a href="/" style={{ color: 'white' }}>
                  Terms and Conditions
                </a>{' '}
                |{' '}
                <a href="/" style={{ color: 'white' }}>
                  Privacy Policy
                </a>
              </p>
              <ul className="footer-social">
                <li>
                  Designed and Developed by{' '}
                  <a href="https://ollcode.com" target="_blank" rel="noopener noreferrer">
                    <b>Ollcode</b>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;